import CallLogWithDurationModelBase from '../_generated/modelBases/call-log-with-duration-model-base';

export default class CallLogWithDurationModel extends CallLogWithDurationModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
